<template>
  <div id="app" class="app" :class="className">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <TheSvgInlineResource/>
    <TheUdnLogo title="聯合報" target="_self" color="rgba(0, 0, 0, 0.8)" @click.native.prevent="onLogoClick" />
    <TheMenu
      title="看懂2020 - 柱柱勇闖南台灣"
      hamburger-color="#e4007f"
      :url="url"/>
    <main class="main">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </main>
    <TheFooter/>
  </div>
</template>

<script>
import debounce from '@/scripts/debounce'
import TheSvgInlineResource from '@/components/TheSvgInlineResource'
import TheUdnLogo from '@/components/TheUdnLogo'
import TheMenu from '@/components/TheMenu'
import TheFooter from '@/components/TheFooter'

export default {
  name: 'App',
  components: {
    TheSvgInlineResource,
    TheUdnLogo,
    TheMenu,
    TheFooter
  },
  data () {
    let isMobile = this.$device.mobile()
    return {
      url: 'https://udn.com/newmedia/election2020/chuchupepper',
      isMobile,
      width: 0,
      height: 0,
      scrollY: 0
    }
  },
  computed: {
    className () {
      let isNarrowDesktop = this.width >= 960 && this.height <= 768
      let isWideScreen1660 = this.width >= 1660
      return {
        'narrow-desktop': isNarrowDesktop,
        'over-screenline': (isNarrowDesktop || isWideScreen1660) && (this.scrollY > this.height)
      }
    }
  },
  methods: {
    onResize: debounce(function () {
      let width = this.width = window.innerWidth
      let height = this.height = window.innerHeight
      let scrollY = this.scrollY = window.pageYOffset
      this.$bus.$emit('resize', { width, height, scrollY })
    }, 50),
    onScroll: debounce(function () {
      this.scrollY = window.pageYOffset
    }, 50),
    onLogoClick () {
      this.$router
        .push('/')
        .catch(err => err)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('scroll', this.onScroll)
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    window.addEventListener('scroll', this.onScroll)
    this.onResize()
    this.onScroll()
  }
}
</script>

<style lang="scss">
.app {
  background: url(~@/assets/background-dot.png) repeat top left;
}

.main {
}
</style>
